
export function toRawIntegerString(rawValue) {
    if (rawValue === null || rawValue === undefined) {
        return null
    }

    if (typeof rawValue === 'bigint') {
        return rawValue.toString()
    }

    if (typeof rawValue === 'number') {
        return Number.isFinite(rawValue) ? String(Math.trunc(rawValue)) : null
    }

    if (typeof rawValue === 'string') {
        const trimmed = rawValue.trim()
        return /^-?\d+$/.test(trimmed) ? trimmed : null
    }

    return null
}

export function toSafeNumber(rawValue) {
    if (rawValue === null) {
        return null
    }

    const asNumber = Number(rawValue)
    return Number.isSafeInteger(asNumber) ? asNumber : null
}

export function toBigIntOrNull(rawValue) {
    if (rawValue === null) {
        return null
    }

    try {
        // eslint-disable-next-line no-undef -- BigInt is a standard ES2020 global; this project's eslint env predates it.
        return BigInt(rawValue)
    } catch {
        return null
    }
}

function normalizeLookupKey(row) {
    const lookupKey = row?.feature?.lookup_key
    return typeof lookupKey === 'string' && lookupKey.length > 0 ? lookupKey : null
}

export function normalizeCapabilityList(rawList) {
    const map = new Map()

    if (!Array.isArray(rawList)) {
        return map
    }

    for (const row of rawList) {
        const lookupKey = normalizeLookupKey(row)

        if (!lookupKey) {
            continue
        }

        if (map.has(lookupKey)) {
            continue
        }

        const rawValue = toRawIntegerString(row.value)
        const isAvailable = rawValue === null ? false : Boolean(row.is_available)
        const isUnlimited = rawValue === null ? false : Boolean(row.is_unlimited)

        map.set(lookupKey, {
            lookupKey,
            name: row?.feature?.name ?? null,
            rawValue,
            isAvailable,
            isUnlimited,
        })
    }

    return map
}

export function normalizeUsageList(rawList) {
    const map = new Map()

    if (!Array.isArray(rawList)) {
        return map
    }

    for (const row of rawList) {
        const lookupKey = normalizeLookupKey(row)

        if (!lookupKey) {
            continue
        }

        if (map.has(lookupKey)) {
            continue
        }

        map.set(lookupKey, {
            lookupKey,
            name: row?.feature?.name ?? null,
            rawUsed: toRawIntegerString(row.used),
            rawLimit: toRawIntegerString(row.limit),
            rawRemaining: toRawIntegerString(row.remaining),
            isUnlimited: Boolean(row.is_unlimited),
        })
    }

    return map
}

export function normalizeQuizFeatureUsageSnapshot(rawJson) {
    const map = new Map()

    if (!rawJson || typeof rawJson !== 'object') {
        return map
    }

    for (const [lookupKey, value] of Object.entries(rawJson)) {
        const rawValue = toRawIntegerString(value)
        if (rawValue === null) {
            continue
        }
        map.set(lookupKey, toSafeNumber(rawValue) ?? 0)
    }

    return map
}

export function getDisplayRemaining(usage) {
    if (!usage || usage.isUnlimited) {
        return null
    }

    const remaining = toSafeNumber(usage.rawRemaining)
    if (remaining === null) {
        return null
    }

    return Math.max(0, remaining)
}
